module.exports = __webpack_public_path__ + "img/newsList_bg.59e224ee.png";